<template>
  <div
    class="control-pre"
    @click="$emit('select')"
    :class="{ select: !onlyShow && select === id, 'control-hover': !onlyShow }"
    :style="{ margin, padding, backgroundColor: config.backgroundColor }"
  >
    <carousel :config="config" v-if="type == 'carousel'"></carousel>
    <article-list
      :config="config"
      v-else-if="type == 'article'"
      :style="{ margin, padding, backgroundColor: config.backgroundColor }"
    ></article-list>
    <file-list :config="config" v-else-if="type == 'file'"></file-list>
    <banner :config="config" v-else-if="type == 'banner'"></banner>
    <guest-list :config="config" v-else-if="type == 'guest'"></guest-list>
    <live-list :config="config" v-else-if="type == 'live'"></live-list>
    <tabs :config="config" v-else-if="type == 'tabs'"></tabs>
    <icons :config="config" v-else-if="type == 'icons'"></icons>
    <a-icon class="icon-close" type="close" @click.stop="$emit('remove')" />
  </div>
</template>

<script>
import carousel from "./carousel";
import articleList from "./article-list";
import fileList from "./file-list";
import banner from "./banner";
import guestList from "./guest-list";
import liveList from "./live-list";
import tabs from "./tabs";
import icons from "./icons";
import { getDistance } from "../../common/js/tool";

export default {
  name: "control-preview",
  props: {
    id: String,
    type: String,
    config: Object,
    onlyShow: Boolean,
  },
  components: {
    carousel,
    articleList,
    fileList,
    banner,
    guestList,
    liveList,
    tabs,
    icons,
  },
  computed: {
    select() {
      return this.$store.getters.select;
    },
    margin() {
      if (this.config) {
        return getDistance(this.config.margin);
      } else {
        return null;
      }
    },
    padding() {
      if (this.config) {
        return getDistance(this.config.padding);
      } else {
        return null;
      }
    },
  },
};
</script>

<style scoped lang="less">
.control-hover {
  &:hover {
    &::after {
      border: 1px dotted var(--main-color);
    }
    & > .icon-close {
      display: block;
    }
  }
}
.control-pre {
  --back-white-color: #ffffff;
  --main-color: #004098;
  position: relative;
  background-color: var(--back-white-color);
  cursor: move;
  .icon-close {
    display: none;
    position: absolute;
    top: 0;
    right: 0;
    width: 20px;
    height: 20px;
    background-color: var(--main-color);
    line-height: 22px;
    text-align: center;
    color: var(--back-white-color);
    cursor: pointer;
    z-index: 2;
  }
  &.select {
    &::after {
      border-color: var(--main-color);
    }
    & > .icon-close {
      display: block;
    }
  }
  &::after {
    content: "";
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    border: 1px solid transparent;
    z-index: 1;
  }
}
</style>
